import { selectEffectiveCompanyId, selectEffectiveUserType } from "../context/contextSelectors"
import { UserType } from "../login/loginTypes"
import { useAppSelector } from "../store/storeHooks"

export function useCurrentSupplier() {
    const userType = useAppSelector(selectEffectiveUserType)
    const supplierId = useAppSelector(selectEffectiveCompanyId)

    if (userType !== UserType.SUPPLIER) {
        throw new Error("Invalid state: not currently acting as a supplier")
    }
    if (!supplierId) {
        throw new Error("Invalid state: effective supplier id not found")
    }

    return {
        supplierId
    }
}
